import React from 'react'
import { Header2 } from '../../styles/Components'
import Button from '../Button'
import { useRouter } from 'next/router'
import { RequestWrapper } from './styles'

const Request = () => {
  const router = useRouter()
  
  const handleClick = () => router.push('/weddings/contact')

  return (
    <RequestWrapper>
      <Header2 align="center">
        Ready to book your
        <br />
        wedding look?
      </Header2>
      <Button onClick={handleClick} large>
        Send a Request
      </Button>
    </RequestWrapper>
  )
}

export default Request
